import React from 'react';
import './assets/styles/main.scss';
import { AuthProvider } from "./context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/layout';
import Dashboard from './pages/dashboard/dashboard';
import Login from "./pages/login/login";
import JobList from './pages/JobList/joblist';
import ForgotPassword from './pages/forgotPassword/ForgotPassword';
import ResetPasswordUsingResetLink from "./pages/forgotPassword/ResetPasswordUsingResetLink";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Candidate from './pages/candidate/candidateList';
import CandidateDetails from './pages/candidate/candidateDetails/CandidateDetails';
import JobDetails from './pages/JobList/JobDetails/JobDetails';
import UserManagement from './pages/masters/users/userManagement';
import Settings from './pages/settings/settings';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Layout><Dashboard /></Layout>
            </PrivateRoute>
          } />
          <Route path="/job-list" element={
            <PrivateRoute>
              <Layout><JobList /></Layout>
            </PrivateRoute>
          } />
          <Route path="/job-list/job-details/:jobDetailId" element={
            <PrivateRoute>
              <Layout hideFilters={true}><JobDetails /></Layout>
            </PrivateRoute>
          } />
          <Route path="/candidate" element={
            <PrivateRoute>
              <Layout><Candidate /></Layout>
            </PrivateRoute>
          } />
          <Route path="/candidate/candidate-details/:id" element={
            <PrivateRoute>
              <Layout hideFilters={true}><CandidateDetails /></Layout>
            </PrivateRoute>
          } />
          <Route path="/user" element={
            <PrivateRoute>
              <Layout hideFilters={true}><UserManagement /></Layout>
            </PrivateRoute>
          } />
          <Route path="/settings" element={
            <PrivateRoute>
              <Layout hideFilters={true}><Settings /></Layout>
            </PrivateRoute>
          } />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword/:token" element={<ResetPasswordUsingResetLink />} />
          <Route path="/Resetpassword" element={<ResetPassword />} />
          <Route path="*" element={
          <PrivateRoute>
            {/* This will redirect to dashboard or login as needed */}
            <></>
          </PrivateRoute>
        } />
        </Routes>
      </AuthProvider>
      <ToastContainer />
    </Router>
  );
}

export default App;